import { defineComponent as _defineComponent } from 'vue';
import { ExternalLink } from 'lucide-vue-next';
import { route } from 'ziggy-js';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderLinkBadge',
    props: {
        order: { type: Object, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { get ExternalLink() { return ExternalLink; }, get route() { return route; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
